export { default as vuex } from './productDetails.store'